var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuatemala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0342C24.8366 32.0342 32 24.8707 32 16.0342C32 7.19762 24.8366 0.0341797 16 0.0341797C7.16344 0.0341797 0 7.19762 0 16.0342C0 24.8707 7.16344 32.0342 16 32.0342Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 16.0339C31.9998 9.69048 28.3082 4.20948 22.9563 1.62148V30.4462C28.3082 27.8582 31.9998 22.3772 31.9998 16.0339V16.0339Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0339C0 22.3772 3.69156 27.8582 9.0435 30.4462V1.62148C3.69156 4.20948 0 9.69048 0 16.0339Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1811 18.7394L17.4757 16.034L20.0509 13.4587L19.9342 12.0986L19.1969 11.3612L15.9999 14.5582L12.8029 11.3612L12.0657 12.0986L11.949 13.4587L14.5242 16.034L11.8187 18.7394L13.2945 20.215L15.9999 17.5097L18.7054 20.215L20.1811 18.7394Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9352 12.0989L18.4595 13.5746C19.0889 14.204 19.4783 15.0736 19.4783 16.0341C19.4783 17.9551 17.921 19.5123 16.0001 19.5123C14.0791 19.5123 12.5218 17.9551 12.5218 16.0341C12.5218 15.0736 12.9111 14.204 13.5406 13.5746L12.0649 12.0989C11.0577 13.1059 10.4348 14.4972 10.4348 16.0341C10.4348 19.1077 12.9264 21.5993 16 21.5993C19.0736 21.5993 21.5652 19.1077 21.5652 16.0341C21.5652 14.4973 20.9423 13.106 19.9352 12.0989V12.0989Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuatemala);
export default __webpack_public_path__ + "static/media/guatemala.c3a9478f.svg";
export { ForwardRef as ReactComponent };